<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close" @click="$emit('close')"></i></button>

        <div class="modal__header"></div>

        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_subscribe_re_optin_title }}</h1>
          <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
        </div>

        <div class="modal__footer">
          <form action="">
            <input
              v-for="subscribeButton in subscribeButtonList"
              :key="subscribeButton.type"
              :value="getTranslations[subscribeButton.text]"
              class="one_time btn btn--medium btn--main"
              style="margin-bottom: 8px;width: 100%;"
              type="submit"
              @click.prevent="emitProceed(subscribeButton.type)"
            />
          </form>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { subscriptionTypeEnum } from '../../../common/mixins/subscription';

export default {
  name: 'SubscribeReoptin',
  emits: ['proceed', 'close'],
  data () {
    return {
      subscribeButtonList: [
        { type: subscriptionTypeEnum.DAILY, text: 'home_modals_subscribe_re_optin_daily_subscription' },
        { type: subscriptionTypeEnum.ONE_TIME, text: 'home_modals_subscribe_re_optin_one_time_subscription' },
      ],
    };
  },
  created () {
    this.showModal();
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  methods: {
    showModal () {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#register_info').fadeOut();
        });
      });
      /* eslint-enable */
    },
    emitProceed (subscriptionType) {
      this.$emit('proceed', subscriptionType);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/SubscribeReoptin.vue